import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { ApiService } from '../../core/services/api.service';

export class LogEntry {
  logId: string;
  dateTime: Date;
  applicationId: string;
  applicationAddress: string;
  userAddress: string;
  customField1: string;
  customField2: string;
  customField3: string;
  customField4: string;
  description: string;
  eventType: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuditlogService {
  logEntry: LogEntry;

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) {}

  logEvent(logEntry: LogEntry) {
    const url = this.apiService.getBaseUrl() + 'auditlog';
    return this.http.post(url, logEntry, {
      observe: 'response',
    });
  }

  logEventByParams(
    eventId: string,
    eventType: string,
    customField1?: string,
    customField2?: string,
    customField3?: string,
    customField4?: string
  ) {
    this.logEntry = new LogEntry();
    this.logEntry.logId = eventId;
    this.logEntry.eventType = eventType;
    this.logEntry.customField1 = customField1 === undefined ? '' : customField1;
    this.logEntry.customField2 = customField2 === undefined ? '' : customField2;
    this.logEntry.customField3 = customField3 === undefined ? '' : customField3;
    this.logEntry.customField4 = customField4 === undefined ? '' : customField4;
    this.logEvent(this.logEntry).subscribe((result) => {});
  }
}
